import { useEffect } from "react";

interface TableFooterShortcutsOptions {
  canOpenBill: boolean;
  canCloseBill: boolean;
  canSplitBill: boolean;
  canAnyReport: boolean;
  hasSelectedBill: boolean;
  /** Закрита без бон сметка — само „Закрий" (повторна фискализация) е
   *  смислено; или масата в процес на закриване — тогава мълчи и F7. */
  isActionDisabled: boolean;
  /** Закриването на избраната маса още чака принтера — F7 мълчи. */
  isClosing: boolean;
  /** Локален режим (docs/edge.md): F2 „Отчет" и F10 „Раздели" мълчат —
   *  касата не ги сервира; F7 „Закрий" работи и за /close/retry. */
  edgeLocal: boolean;
  /** Режим „Схема" без избрана маса за отваряне (свободна или със сметка в закриване) —
   *  „Нова маса" е заключена, F5 мълчи. */
  newTableDisabled?: boolean;
  onNewTable?: () => void;
  onAddToTable?: () => void;
  onClose: () => void;
  onReport: () => void;
  onSplit: () => void;
}

/**
 * Клавишите на лентата под масите: F5 Нова · F6 Добави · F7 Закрий ·
 * F2 Отчет · F10 Раздели (docs/ordering.md). Игнорират се при фокус в
 * поле за писане. Изваден от TableFooter.
 */
export function useTableFooterShortcuts({
  canOpenBill,
  canCloseBill,
  canSplitBill,
  canAnyReport,
  hasSelectedBill,
  isActionDisabled,
  isClosing,
  edgeLocal,
  newTableDisabled = false,
  onNewTable,
  onAddToTable,
  onClose,
  onReport,
  onSplit,
}: TableFooterShortcutsOptions) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        e.target instanceof HTMLElement &&
        (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA")
      )
        return;

      switch (e.key) {
        case "F5":
          e.preventDefault();
          if (canOpenBill && !newTableDisabled) onNewTable?.();
          break;
        case "F6":
          e.preventDefault();
          if (canOpenBill && hasSelectedBill && !isActionDisabled)
            onAddToTable?.();
          break;
        case "F7":
          e.preventDefault();
          if (canCloseBill && hasSelectedBill && !isClosing) onClose();
          break;
        case "F2":
          e.preventDefault();
          if (canAnyReport && !edgeLocal) onReport();
          break;
        case "F10":
          e.preventDefault();
          if (canSplitBill && hasSelectedBill && !isActionDisabled && !edgeLocal)
            onSplit();
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    canOpenBill,
    canCloseBill,
    canSplitBill,
    canAnyReport,
    hasSelectedBill,
    isActionDisabled,
    isClosing,
    edgeLocal,
    newTableDisabled,
    onNewTable,
    onAddToTable,
    onClose,
    onReport,
    onSplit,
  ]);
}
